export default "__VITE_ASSET__97f5db08__"